var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuzuki(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 951.1 951.1",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M941.322 654.608s-87.2 25.3-256.3 129.2c-151.8 93.3-211.3 156-211.3 156l-467.8-323.3s196.8-144.7 361.3-33.9l220.6 151.3 26.9-17.7-608.8-426.3s87.5-25.3 256.6-129.2c151.9-93.4 211.2-156.1 211.2-156.1l468 323.3s-196.8 144.8-361.3 33.9l-220.6-151.4-26.9 17.7 608.4 426.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuzuki);
export default __webpack_public_path__ + "static/media/suzuki.c0ce260932c43dd6b0eaee3a3d7b1951.svg";
export { ForwardRef as ReactComponent };